"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hiddenDemoMode = void 0;
/**
 * 偏好设置中，可以开启“隐藏模拟模式”，这个开关的的状态值是存储在 LocalStorage 中。
 * 并且 APP 端的 LocalStorage 的读取是【异步】的。
 * 所以，这里 export 的单例主要是让 trade_future_lib 中的函数可以【同步】获取这个开关的状态。
 * 所以在 C 端要找个时机（一般是 app.tsx/index.tsx ）设置 isHiddenDemoMode：hiddenDemoMode.isHiddenDemoMode = true/false。
 */
class HiddenDemoMode {
    constructor() {
        this.isHiddenDemoMode = false;
    }
}
exports.hiddenDemoMode = new HiddenDemoMode();
